export type Maybe<T> = T | null;

export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export enum ClubStatus {
  Active = 'Active',
  Terminated = 'Terminated',
  Suspended = 'Suspended',
}

export enum WeekdayFull {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
}

export enum ClubType {
  RotaractClub = 'Rotaract Club',
  RotaractSatelliteClub = 'Rotaract Satellite Club',
  RotaryClub = 'Rotary Club',
  SatelliteClub = 'Satellite Club',
}

export type FetchAllDistrictClubsQuery = {
  TotalCount: number;
  Clubs: Array<{
    id: string;
    riClubId: string;
    clubName: string;
    clubType: ClubType;
    status?: string | null | undefined;
    country?: string | null | undefined;
    state?: string | null | undefined;
    countryId: string;
    city?: string | null | undefined;
    stateId?: string | null | undefined;
    internationalProvince?: string | null | undefined;
  }>;
};

export type DistrictData = {
  id: Scalars['String'];
  riDistrictId: Scalars['Int'];
};

export type LocationData = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryId: Scalars['String'];
  internationalProvince?: Maybe<Scalars['String']>;
  lineOne?: Maybe<Scalars['String']>;
  lineThree?: Maybe<Scalars['String']>;
  lineTwo?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['String']>;
};

export type BaseAddress = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internationalProvince?: Maybe<Scalars['String']>;
  lineOne?: Maybe<Scalars['String']>;
  lineThree?: Maybe<Scalars['String']>;
  lineTwo?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['String']>;
};

export enum MeetingType {
  Hybrid = 'Hybrid',
  Online = 'Online',
  Physical = 'Physical',
}

export type Meeting = {
  address?: Maybe<BaseAddress>;
  comment?: Maybe<Scalars['String']>;
  detailForJoiningRemotely?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  languageId?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  locationNameOrDetail?: Maybe<Scalars['String']>;
  locationVaries: Scalars['Boolean'];
  longitude?: Maybe<Scalars['Float']>;
  meetingId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onlineLocation?: Maybe<Scalars['String']>;
  time: Scalars['String'];
  type: MeetingType;
  weekday: WeekdayFull;
};

export type DistrictClub = {
  clubId: Scalars['String'];
  clubName: Scalars['String'];
  clubType: ClubType;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  nfKey: Scalars['String'];
  nfId: Scalars['String'];
  activeMembers?: Maybe<Scalars['Int']>;
  assistantGovernor?: Maybe<Scalars['String']>;
  agId?: Maybe<Scalars['String']>;
};

export type GetAllDistrictAGsByDateQuery = {
  totalCount: number;
  AssistantGovernors: Array<
    | {
        individualId: string;
        firstName: string;
        lastName: string;
        middleName?: string | null | undefined;
        prefix?: string | null | undefined;
        suffix?: string | null | undefined;
        localizedName?: string | null | undefined;
        clubAffiliations?:
          | Array<
              | {
                  clubId: string;
                  districtMappingId: string;
                  clubGroupingMappingId: string;
                  clubType: string;
                  clubName: string;
                  startDate: string;
                  endDate: string;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined
  >;
};

export interface Affiliation {
  type: string;
  admissionDate: string;
  terminationDate: string | null;
  endDate: string | null;
  startDate: string;
  isDelegated: boolean;
  role: string;
  activeAssignment: boolean;
}
export interface ClubMeeting {
  weekday: string;
  time: string;
  type: string;
  locationVaries: boolean;
}
export interface ClubDistrict {
  id: string;
  riDistrictId: string;
  zone: string;
}
export interface ClubAffiliation {
  riClubId?: string;
  id: string;
  name: string;
  fullName: string;
  endDate: string | null;
  startDate: string;
  city: string | null;
  stateName: string | null;
  countryName: string | null;
  internationalProvince: string | null;
  activeAssignment: boolean;
  meetings: ClubMeeting[];
  type: string;
  role: string;
  affiliation: Affiliation[];
  district: ClubDistrict[];
  formattedClubType: string;
  zone?: string;
}

export enum MembershipType {
  Honorary = 'Honorary Member',
  Member = 'Member',
  RotaractHonorary = 'Rotaract Honorary Member',
  Rotaractor = 'Rotaractor',
}

export enum Reason {
  Age = 'Age',
  BusinessObligations = 'BusinessObligations',
  ByClubForCause = 'ByClubForCause',
  Deceased = 'Deceased',
  FamilyObligations = 'FamilyObligations',
  Health = 'Health',
  JoiningNewClub = 'JoiningNewClub',
  JoiningRotaryClub = 'JoiningRotaryClub',
  LackOfParticipation = 'LackOfParticipation',
  NoContactUpdate = 'NoContactUpdate',
  NonAttendance = 'NonAttendance',
  NonPaymentOfClubDues = 'NonPaymentOfClubDues',
  Personal = 'Personal',
  Relocation = 'Relocation',
  SchoolGraduation = 'SchoolGraduation',
}

export enum MembershipStatusFilter {
  Active = 'Active',
  Deceased = 'Deceased',
  Honorary = 'Honorary',
  HonoraryRotaractor = 'Honorary Rotaractor',
  Rotaractor = 'Rotaractor',
  Terminated = 'Terminated',
}
export type MembershipAffiliation = {
  admissionDate: string;
  id: string;
  membershipType: MembershipType;
  terminationDate?: string;
};

export type OtherId = {
  individualOtherId: string;
  idType: string;
  value: string;
};

export type Membership = {
  clubId?: string | null | undefined;
  clubName?: string | null | undefined;
  type: string | undefined;
  admissionDate?: string | null | undefined;
  terminationDate?: string | null | undefined;
  clubType?: string | null | undefined;
};
